import React from 'react';
import styles from './ProjectTable.module.scss';
import {
  ProjectCounters,
  ProjectRow
} from '../../../../../../../../../Models/ProjectValue';
import { SFScrollable, SFText } from 'sfui';
import { durationTimeFormat } from '../../../../../helpers';
import { NoReportsMessage } from '../NoReportsMessage/NoReportsMessage.';
import { LimitReportsIcon } from '../LimitReportsIcon/LimitReportsIcon';
import { InteractiveBox } from 'ui-smartforce-settings';
import { PROJECT_REPORTS_LIMIT } from '../ProjectCardDetailsList';

export interface ProjectTableProps {
  counters: ProjectCounters;
  rows: ProjectRow[];
  onSeeDateRowReports: (index: number) => void;
}
export const ProjectTable = ({
  counters,
  rows,
  onSeeDateRowReports
}: ProjectTableProps): React.ReactElement<ProjectTableProps> => {
  return (
    <div className={styles.projectTable}>
      <div className={styles.header}>
        <SFText type="component-messages" sfColor="neutral">
          DATE{' '}
          <span
            className={styles.counterChip}
          >{`${counters.days} ${counters.days === 1 ? 'day' : 'days'}`}</span>
        </SFText>
        <SFText type="component-messages" sfColor="neutral">
          REPORTS <span className={styles.counterChip}>{counters.reports}</span>{' '}
          {counters.reports >= PROJECT_REPORTS_LIMIT && <LimitReportsIcon />}
        </SFText>

        <SFText type="component-messages" sfColor="neutral">
          WARNINGS{' '}
          <span className={styles.counterChip}>{counters.warnings}</span>
        </SFText>

        <SFText type="component-messages" sfColor="neutral">
          CITATIONS{' '}
          <span className={styles.counterChip}>{counters.citations}</span>
        </SFText>

        <SFText type="component-messages" sfColor="neutral">
          ARRESTS <span className={styles.counterChip}>{counters.arrests}</span>
        </SFText>

        <SFText type="component-messages" sfColor="neutral">
          TIME SPENT{' '}
          <span className={styles.counterChip}>
            {durationTimeFormat(counters.time_spent)}
          </span>
        </SFText>
      </div>
      {rows.length > 0 && (
        <SFScrollable
          className={styles.scrollable}
          containerClassName={styles.rows}
        >
          <>
            {rows.map((row: ProjectRow, index: number) => (
              <InteractiveBox
                key={row.reports_date}
                className={styles.row}
                onClick={() => onSeeDateRowReports(index)}
              >
                <SFText type="component-2" sfColor="default">
                  {row.reports_date}
                </SFText>
                <SFText type="component-2" sfColor="default">
                  {row.reports}
                </SFText>

                <SFText type="component-2" sfColor="default">
                  {row.warnings}
                </SFText>

                <SFText type="component-2" sfColor="default">
                  {row.citations}
                </SFText>

                <SFText type="component-2" sfColor="default">
                  {row.arrests}
                </SFText>

                <SFText type="component-2" sfColor="default">
                  {durationTimeFormat(row.time_spent)}
                </SFText>
              </InteractiveBox>
            ))}
          </>
        </SFScrollable>
      )}

      {rows.length === 0 && <NoReportsMessage />}
    </div>
  );
};
